const actions = {
  FETCH_TAGX: 'FETCH_TAGX',
  FETCH_TAGX_SUCCESS: 'FETCH_TAGX_SUCCESS',
  FETCH_TAGX_ERROR: 'FETCH_TAGX_ERROR',
  TAGX_SET: 'tagx/SET_VALUE',
  TAGX_ADD: 'tagx/ADD_VALUE',
  TAGX_DEL: 'tagx/DEL_VALUE',
  TAGX_SUCCESS: 'tagx/SUCCESS',
  TAGX_ERROR: 'tagx/ERROR',
}

export default actions
